export interface CustomerInfo {
  email: string;
  register: string;
  lastName: string;
  firstName: string;
  phone: string;
}

export type HuulgaQuarter = "Q1" | "Q2" | "Q3" | "Q4";

export const HUULGA_QUARTERS: HuulgaQuarter[] = [
  "Q1",
  "Q2",
  "Q3",
  "Q4",
];

export type HuulgaLegacyFileTypeKey =
  | "haNiitText"
  | "tseneglelText"
  | "zarlagaText"
  | "buitsaaltText";

export type HuulgaQuarterFileTypeKey =
  | "niitHudaldanAvaltText"
  | "niitTsenegleltText"
  | "buitsaaltBondText"
  | "buitsaaltStockText";

export interface OrlogoZarlagaRow {
  key: string;
  year: number;
  date: string;
  income: string;
  expense: string;
  description: string;
  depositDate: string;
}

export interface HudaldanAvaltRow {
  key: string;
  year: number;
  date: string;
  amount: string;
  batchNo: string;
  bond: string;
  estate: string;
  lockAmount: string;
  fx: string;
  dia: string;
  vde: string;
  vug: string;
  vxf: string;
}

export interface QuarterHudaldanAvaltRow {
  key: string;
  year: number;
  quarter: HuulgaQuarter;
  dateTime: string;
  date: string;
  amount: string;
  batchNo: string;
  bondName: string;
  bond: string;
  lockAmount: string;
  holdings: Record<string, string>;
}

export interface TsenegleltRow {
  key: string;
  year: number;
  quarter: HuulgaQuarter;
  date: string;
  lastName: string;
  firstName: string;
  register: string;
  phone: string;
  email: string;
  purpose: string;
  amount: string;
  description: string;
  depositDate: string;
}

export interface BuitsaaltRow {
  key: string;
  year: number;
  calcDate: string;
  assetName: string;
  principal: string;
  bondInterest: string;
  days: string;
  calcInterest: string;
  total: string;
  avtamataFee: string;
  tradingFee: string;
  tax: string;
  transferAmount: string;
  account: string;
}

export interface BondRefundRow {
  key: string;
  year: number;
  quarter: HuulgaQuarter;
  email: string;
  phone: string;
  lastName: string;
  firstName: string;
  register: string;
  account: string;
  bankName: string;
  purpose: string;
  ttd: string;
  assetName: string;
  principal: string;
  bondInterestRate: string;
  purchaseDate: string;
  calcDate: string;
  days: string;
  calcInterest: string;
  interestThirtyPercent: string;
  total: string;
  avtamataFee: string;
  tradingFee: string;
  tax: string;
  transferAmount: string;
}

export interface StockRefundRow {
  key: string;
  year: number;
  quarter: HuulgaQuarter;
  email: string;
  phone: string;
  lastName: string;
  firstName: string;
  register: string;
  account: string;
  bankName: string;
  purpose: string;
  ttd: string;
  assetType: string;
  purchaseDate: string;
  stockName: string;
  quantity: string;
  stockPrice: string;
  usdRate: string;
  grossTotal: string;
  tradingFee: string;
  avtamataFee: string;
  transferAmount: string;
}

export interface YearData {
  year: number;
  haNiitText: string;
  tseneglelText: string;
  zarlagaText: string;
  buitsaaltText: string;
}

export interface YearFileInfo {
  year: number;
  fileType: string;
  fileName?: string;
  updatedAt?: string;
}

export interface YearQuarterData {
  year: number;
  quarter: HuulgaQuarter;
  niitHudaldanAvaltText: string;
  niitTsenegleltText: string;
  buitsaaltBondText: string;
  buitsaaltStockText: string;
}

export interface YearQuarterFileInfo {
  year: number;
  quarter: HuulgaQuarter;
  fileType: HuulgaQuarterFileTypeKey;
  fileName?: string;
  updatedAt?: string;
}

export interface SearchResult {
  customer: CustomerInfo;
  orlogoZarlaga: OrlogoZarlagaRow[];
  hudaldanAvalt: HudaldanAvaltRow[];
  buitsaalt: BuitsaaltRow[];
}

export interface QuarterSearchResult {
  customer: CustomerInfo;
  hudaldanAvalt: QuarterHudaldanAvaltRow[];
  tseneglelt: TsenegleltRow[];
  bondRefunds: BondRefundRow[];
  stockRefunds: StockRefundRow[];
  holdingKeys: string[];
}
